import { render, staticRenderFns } from "./navDrawerForCollegePanel.vue?vue&type=template&id=06719c17&"
import script from "./navDrawerForCollegePanel.vue?vue&type=script&lang=js&"
export * from "./navDrawerForCollegePanel.vue?vue&type=script&lang=js&"
import style0 from "./navDrawerForCollegePanel.vue?vue&type=style&index=0&id=06719c17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports